import classNames from 'classnames';
import { type ReactNode } from 'react';

import styles from '../../styles/partials/line-spacer.module.css';

interface LineSpacerProps {
    children?: ReactNode;
    className?: string | null;
}

function LineSpacer({ children = null, className = null }: LineSpacerProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.line} />
            <div className={styles.label}>{children}</div>
            <div className={styles.line} />
        </div>
    );
}

export default LineSpacer;
